// extracted by mini-css-extract-plugin
export var paginationContainer = "_44-0";